import Layout from "../../components/Layout";

import "./style.css";

const Notification = () => {
  return (
    <Layout>
      <div class="form-container">
        <input type="text" id="name" placeholder="Bildirim Başlığı" />
        <select id="options">
          <option value="secenek1">Seçenek 1</option>
          <option value="secenek2">Seçenek 2</option>
          <option value="secenek3">Seçenek 3</option>
        </select>
        <textarea id="message" placeholder="Bildirim Mesajını Girin"></textarea>
        <button id="submitBtn">Gönder</button>
      </div>
    </Layout>
  );
};

export default Notification;
